/*
 * WARNING: due to time contraints this module also gets used in the client code.
 *
 * Don't import serverside code into this file (e.g. db client)
 */

import type { env as serverEnv } from '../../env';
import type { ZohoModuleSDK } from './sdk';

export namespace ZohoLaravelAPI {
    /** A temporary cache so that we don't accidentally fetch the same image multiple times.
     * The Laravel API is very slow at returning images
     *
     * NOTE: monitor if this doesn't cause our functions to run out of memory.
     * It shouldn't because the functions get killed after returning. */
    const CACHE = new Map<`/${string}`, Blob>();

    const CONFIG = {
        baseURL: '/api/zoho/app',
    } as const;

    async function downloadPDF(path: `/${string}`) {
        const cached = CACHE.get(path);
        if (cached) return { ok: true, cached: true, blob: cached } as const;

        const env = (typeof window === 'undefined'
            ? process.env
            : null) as unknown as typeof serverEnv;
        const url = `${
            (() => {
                if (typeof window !== 'undefined') {
                    return window.location.origin;
                }

                const host = env.VERCEL_URL || env.VERCEL_BRANCH_URL;
                if (host) return `https://${host}`;

                return 'http://localhost:3001';
            })() satisfies string
        }${CONFIG.baseURL}${path}`;

        const response = await fetch(url, {
            method: 'GET',
            referrerPolicy: 'no-referrer',
            mode: 'cors',
            headers:
                typeof window !== 'undefined'
                    ? // User credentials will be used
                      undefined
                    : {
                          Authorization: `Bearer ${env.FUNKEY_INTERNAL_API_TOKEN}`,
                      },
        });

        if (!response.ok) {
            return {
                ok: false,
                url,
                status: response.status,
                statusText: response.statusText,
                response: response.headers.get('Content-Type')?.includes('application/json')
                    ? await response.json()
                    : await response.text(),
                headers: Object.fromEntries(response.headers.entries()),
            } as const;
        }

        const blob = await response.blob();
        CACHE.set(path, blob);
        return { ok: true, cached: false, blob } as const;
    }

    export async function getInvoicePDF(zInvoiceID: ZohoModuleSDK.ZohoID) {
        return downloadPDF(`/invoices/download-pdf/${zInvoiceID}`);
    }
    export async function getQuotePDF(zQuoteID: ZohoModuleSDK.ZohoID) {
        return downloadPDF(`/quotes/download-pdf/${zQuoteID}`);
    }
}
